import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import {LoadingController, ModalController, ToastController} from '@ionic/angular';
import {HttpClient} from '@angular/common/http';
import {API_IP} from '../../util/config';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-airport-list',
  templateUrl: './airport-list.component.html',
  styleUrls: ['./airport-list.component.scss'],
})
export class AirportListComponent implements OnInit {
  @ViewChild('resetPasswordHeader') resetPasswordHeader: HeaderComponent;
  @Input() arp;
  requestURL;
  airportList: any;
  airportListCopy: any;
  airport = '';
  constructor(
      public modalController: ModalController,
      public toastController: ToastController,
      public loadingController: LoadingController,
      public http: HttpClient,
      public translateService: TranslateService
  ) { }

  async ngOnInit() {
    await this.presentLoading();
    const result = await this.getAirportList().toPromise();

    this.airportList = await JSON.parse(result['data']);
    this.airportListCopy = await this.airportList;
    // console.log(this.airportList);
    await this.closeLoading();
  }

  getAirportList() {
    this.requestURL = API_IP + '/api/data/airport';
    return this.http.post(this.requestURL , {});
  }

  async changeSearch(event) {
    event.detail.value = await event.detail.value.toUpperCase();
    console.log(event.detail.value);

    // await this.presentLoading();

    if (event.detail.value === '') {
      this.airportListCopy = await this.airportList;
      // await this.closeLoading();
      return;
    }

    const searchResult = [];
    await this.airportList.filter(a => {
      if (a.airport.indexOf(event.detail.value) > -1) {
        searchResult.push(a);
      }
      if ( a.name && (a.name.indexOf(event.detail.value) > -1)) {
        searchResult.push(a);
      }
    });

    if (searchResult.length === 0) {
      // await this.noResultToast();
      this.airportListCopy = [];
    } else {
      this.airportListCopy = searchResult;
    }
    // await this.closeLoading();
  }

  chooseArp(airport) {
    this.airport = airport;
    this.close();
  }

  close() {
    this.dismiss();
  }

  dismiss() {
    // using the injected ModalController this page
    // can 'dismiss' itself and optionally pass back data
    this.modalController.dismiss({
      'dismissed': true,
      'airport': this.airport // 传出机场三字码
    });
  }

  async noResultToast() {// 显示通知框
    const toast = await this.toastController.create({
      message: this.translateService.instant('common_label_no_searching_airport_result'),
      duration: 2000,
      position: 'top',
      cssClass: 'toast_style',
    });
    toast.present();
  }

  async presentLoading() {
    const loading = await this.loadingController.create({
      message: this.translateService.instant('common_label_loading')
    });
    await loading.present();
  }

  closeLoading() {
    this.loadingController.dismiss({
      'dismissed': true
    });
  }

}
